import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './index.css';

const cardData = [
    {
        imgSrc: 'conventional-loan.webp',
        title: 'Conventional Loans',
        heading: 'Conventional Loans',
        text: `The most popular loan type as it typically offers low interest rates, fast processing and more flexibility. A conventional mortgage or conventional loan is any type of homebuyer's loan that is not offered or secured by a government entity, but rather available through or guaranteed by a private lender or the two government-sponsored enterprises Fannie Mae and Freddie Mac.`,
    },
    {
        imgSrc: 'down-payment-assistance.webp',
        title: 'Down Payment Assistance',
        heading: 'Down Payment Assistance',
        text: `Coming up with a down payment to purchase a new home can feel like a giant obstacle. Down payment assistance programs can help. They typically vary from state to state, ask your local Market Manager about options in your area.`,
    },
    {
        imgSrc: 'fha-loan.webp',
        title: 'FHA Loans',
        heading: 'FHA Loans',
        text: `This is the most common option for a first-time homebuyer. The FHA loan is a federally backed loan that allows the buyer to put down a smaller down payment, typically has a competitive interest rate, and is more lenient when reviewing your credit history.`,
    },
    {
        imgSrc: 'jumbo-loan.webp',
        title: 'Jumbo Loans',
        heading: 'Jumbo Loans',
        text: `When you purchase a new home, there are typically limits on the amount of money you can borrow. With stricter qualifications, a Jumbo loan allows you to borrow more money than a conventional loan would so you can purchase a more expensive property.`,
    },
    {
        imgSrc: 'refinancing.webp',
        title: 'Refinancing',
        heading: 'Refinancing',
        text: `With interest rates being very low, now is a great time to consider a refinance. Benefits of refinancing include obtaining a lower interest rate, changing your loan term (paying off your mortgage sooner, reducing payments by extending, or switching from an ARM to a Fixed), consolidating debt, or taking cash out for home improvements.`,
    },
    {
        imgSrc: 'renovation-loan.webp',
        title: 'Renovation Loans',
        heading: 'Renovation Loans',
        text: `A loan option that allows you to add extra money for remodeling or improvements to an initial home purchase mortgage or a mortgage refinancing.`,
    },
    {
        imgSrc: 'reverse-mortgage.webp',
        title: 'Reverse Mortgage',
        heading: 'Reverse Mortgage',
        text: `Available to homeowners 62 years or older, convert part of the equity in your home into cash. Each month instead of making a payment to us, we’ll send you money that can be used for anything you want including living expenses, health care, and travel. You maintain ownership of your home and are still responsible for paying property tax and homeowner’s insurance.`,
    },
    {
        imgSrc: 'usda-loan.webp',
        title: 'USDA Loans',
        heading: 'USDA Loans',
        text: `For prospective homebuyers who are looking for property in a rural area, a USDA loan offers the option to purchase a home with no down payment. These government loans are meant to help revitalize rural landscapes by increasing home ownership, encouraging development, and assisting with rehabilitation projects.`,
    },
    {
        imgSrc: 'va-loan.webp',
        title: 'VA Loans',
        heading: 'VA Loans',
        text: `A VA loan is available to eligible military veterans and their surviving spouses. It allows you to purchase a home with 0% down, minimal closing costs, and fewer restrictions than a traditional loan.`,
    },
];

const CardGrid = () => {
    const [activeCard, setActiveCard] = useState(null);

    const handleCardClick = (index) => {
        // Toggle the active card on mobile view
        if (window.innerWidth <= 769) { // Apply hover effect only on desktop
        setActiveCard(activeCard === index ? null : index);
        }
    };

    const handleMouseEnter = (index) => {
        if (window.innerWidth >= 769) { // Apply hover effect only on desktop
            setActiveCard(index);
        }
    };

    const handleMouseLeave = () => {
        if (window.innerWidth >= 769) { // Remove hover effect only on desktop
            setActiveCard(null);
        }
    };

    const imgCDNURL = process.env.REACT_APP_CDN_URL + "eaimortgage/images/";

    return (
        <section className="card-grid-section">
            <Container>
                <h3 className="loan-programs-heading">Understanding the Primary Loan Types</h3>
                <p className="loan-programs-para">Below are some of the programs offered here at EvolutionAI Mortgage</p>
                <Row className="card-grid">
                    {cardData.map((card, index) => (
                        <Col
                            key={index}
                            xs={12}
                            md={4}
                            className="mb-4 d-flex justify-content-center"
                        >
                            <div
                                className={`card-item ${activeCard === index ? 'active' : ''}`}
                                onClick={() => handleCardClick(index)} // Only for mobile view
                                onMouseEnter={() => handleMouseEnter(index)} // For desktop
                                onMouseLeave={handleMouseLeave} // For desktop
                            >
                                {activeCard === index ? (
                                    <div className="card-content">
                                        <h3 className="card-heading">{card.heading}</h3>
                                        <p className="card-text">{card.text}</p>
                                    </div>
                                ) : (
                                    <>
                                        <div className="card-img-container">
                                            <img src={imgCDNURL + card.imgSrc} alt={card.title} className="card-img" />
                                        </div>
                                        <h3 className="card-title">{card.title}</h3>
                                    </>
                                )}
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default CardGrid;
